<template>
    <div class="standard-form">
        <div class="general-title">
            <div class="title">Make A Journal Entry</div>
            <div class="buttons-container buttons">
                <a href="/tracker/behaviors/log" class="neutral-bg">Go Back<span class="fa fa-arrow-left"></span></a>
            </div>
        </div>
        <form action="/tracker/behaviors/log" method="post" @submit="loading = true">
        <csrf></csrf>
        <div class="input-container">
            <div class="input-title">Behavior To Journal</div>
            <div class="input-box">
                <selectize v-model="form.behavior_id" name="behavior_id" placeholder="Search Behaviors">
                    <option v-for="behavior in behaviors" :key="behavior.id" :value="behavior.id">{{ behavior.description }}</option>
                </selectize>
            </div>
        </div>
        <div class="input-container">
            <div class="input-title">Selected Behavior</div>
            <div v-if="behavior" class="input-box static-text">
                <i :class="levelTextClass(behavior.level)">Level {{ behavior.level }}</i><br>
                {{ behavior.description }}
            </div>
            <div v-else class="input-box static-text">
                Please select a behavior. You can add a new one <a href="/tracker/behaviors/create">here.</a>
            </div>
        </div>
        <div class="input-container">
            <div class="input-title">Notes (Optional)</div>
            <div class="input-box"><textarea name="notes" placeholder="If you have notes regarding this behavior entry, please type them here..."></textarea></div>
        </div>
        <button v-if="!loading" type="submit" class="submit-standard good-bg">Log Behavior<span class="fa fa-plus"></span></button>
        <button v-if="loading" type="submit" class="submit-standard neutral-bg" disabled>Processing...</button>
        </form>
    </div>
</template>

<script>

import LevelsMixin from '@/mixins/LevelsMixin';
import _ from 'underscore';

export default {

    props: [ 'behaviors' ],

    mixins: [ LevelsMixin ],

    data() {
        return {
            loading: false,
            form: {},
        }
    },

    computed: {

        behavior() {
            return _.findWhere(this.behaviors, { id: parseInt(this.form.behavior_id) }) || null;
        }
    }

}

</script>



// WEBPACK FOOTER //
// resources/js/components/tracker/CreateBehaviorLog.vue